<div class="h-100 d-flex justify-content-around align-items-center gap-0_5">
  <i class="cp icon-comment fs-4" (click)="onClick('comment')" tooltip="Comment">
    <span class="icon-wrapper" *ngIf="currentRow.comment?.length > 0">
      <i class="fas fa-circle top-right-icon"></i>
    </span>
  </i>
  <i class="cp fas fa-coins" (click)="onClick('adjustBalance')" tooltip="Adjust balance" *ngIf="canAdjustBalance()"></i>
  <i class="cp icon-log-in" (click)="onClick('login')" tooltip="Login"></i>
  <i class="cp icon-edit" (click)="onClick('edit')" tooltip="Edit user"></i>
  <i class="cp icon-more" (click)="onClick('more')" tooltip="More actions"></i>
</div>
